<mat-form-field appearance="outline" class="b2b-datepicker w-100">
    <input matInput [matDatepicker]="picker" (click)="picker.open()" [matDatepickerFilter] ="filterDate" [(ngModel)]="value"
        (dateChange)="dateChange($event)" readonly>
        <mat-datepicker #picker></mat-datepicker>
</mat-form-field>